import { Button, TextInput } from 'components/common'
import { useFormContext, useWatch } from 'react-hook-form'
import { useMemo, useState } from 'react'
import { PickerMapping } from 'types/pickerMap'

type Props = {
  field: PickerMapping
  index: number
  originalData: PickerMapping
  onSave: (index: number, id: string) => void
  onDelete: (index: number, id: string) => void
}

const PickerMapItem = ({
  field,
  index,
  originalData,
  onSave,
  onDelete,
}: Props) => {
  const {
    register,
    control,
    handleSubmit,
    formState: { errors },
  } = useFormContext<{
    mappings: PickerMapping[]
  }>()

  const pickerName = useWatch({ control, name: `mappings.${index}.pickerName` })
  const empId = useWatch({ control, name: `mappings.${index}.empId` })

  const [saving, setSaving] = useState(false)

  const isChanged = useMemo(() => {
    return (
      pickerName !== originalData.pickerName || empId !== originalData.empId
    )
  }, [pickerName, empId, originalData])

  const onSubmit = async () => {
    setSaving(true)
    await onSave(index, field._id)
    setSaving(false)
  }

  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      className="mb-2 grid grid-cols-3 gap-4"
    >
      <TextInput
        name={`mappings.${index}.pickerName`}
        register={register}
        error={errors?.mappings?.[index]?.pickerName?.message}
      />
      <TextInput
        name={`mappings.${index}.empId`}
        register={register}
        error={errors?.mappings?.[index]?.empId?.message}
      />
      <div className="flex max-h-[42px] items-stretch gap-5">
        <Button
          className="w-full"
          type="submit"
          disabled={!isChanged || saving}
          buttonText="Save"
          loading={saving}
        />
        <Button
          disabled={saving}
          className="w-full"
          type="button"
          onClick={() => onDelete(index, field._id)}
          buttonText="Delete"
        />
      </div>
    </form>
  )
}

export default PickerMapItem
